<template>
  <div class="market-switcher-data" />
</template>

<script>

/**
 * Vue: Market Switcher Data (market-switcher-data)
 * -----------------------------------------------------------------------------
 * Used to read localization data from liquid.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'MarketSwitcherData',

  props: {
    localization: {
      type: Object,
      default: () => ({
        countries: [],
        languages: [],
      }),
    },
    country: {
      type: Object,
      default: () => ({
        name: '',
        code: '',
      }),
    },
    language: {
      type: Object,
      default: () => ({
        name: '',
        code: '',
      }),
    },
  },

  mounted() {
    this.setLocalization(this.localization)
    this.setCountry(this.country)
    this.setLanguage(this.language)
    this.checkMarketPreference()
  },

  methods: {
    ...mapActions({
      setLocalization: 'market-switcher/setLocalization',
      setCountry: 'market-switcher/setCountry',
      setLanguage: 'market-switcher/setLanguage',
    }),

    /**
     * Check market preference.
     */
    checkMarketPreference() {
      const preferred_country = localStorage.getItem('preferred_country')
      const preferred_language = localStorage.getItem('preferred_language')

      if (!preferred_country || !preferred_language) {
        return
      }

      if (
        window.Shopify.country === preferred_country &&
        window.Shopify.locale === preferred_language
      ) return

      const formData = new FormData()

      formData.append('return_to', `${window.location.pathname}${new URLSearchParams(window.location.search)}${window.location.hash}`)
      formData.append('_method', 'put')
      formData.append('country_code', preferred_country)
      formData.append('language_code', preferred_language)

      fetch('/localization', {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: new URLSearchParams(formData).toString(),
      })
      .then(response => {
        if (!response.ok) return

        window.location = response.url
      })
      .catch(error => {
        console.log(error)
      })
    },
  },
}
</script>
